import React from "react"
import { graphql } from "gatsby"
import EventCard from "../../cards/event"

const EventSelector = ({ events }) => {
  return (
    <section className="event-selector" id='#events'>
      <div className="event-selector__inner">
        <div className="event-selector__items">
          {
            events?.length > 0 && events.map((item, i) => (
              <EventCard key={i} buttons={true} template={true} {...item} />
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default EventSelector

export const query = graphql`
    fragment EventSelectorProps on DatoCmsEventSelector {
      ... on DatoCmsEventSelector {
        id
        events {
          title
          stands
          seats
          richContent {
            value
          }
          slug
          permalink
          notableFeatures {
            title
          }
          jsonLd
          gallery {
            ...InternalAssetProps
          }
          floorplans {
            ...InternalAssetProps
          }
          categories {
            title
          }
          button {
            ...LinkWithTitleProps
          }
        }
      }
    }
`